/**
 * Permission-Konstanten - Spiegelt das Backend Permission-Enum.
 * Single Source of Truth: backend/app/core/permissions.py
 */

// Projekte
export const PROJEKTE_VIEW = 'projekte:view';
export const PROJEKTE_CREATE = 'projekte:create';
export const PROJEKTE_EDIT = 'projekte:edit';
export const PROJEKTE_DELETE = 'projekte:delete';

// Audits
export const AUDITS_VIEW = 'audits:view';
export const AUDITS_VIEW_ALL = 'audits:view_all';
export const AUDITS_CREATE = 'audits:create';
export const AUDITS_EDIT = 'audits:edit';
export const AUDITS_DELETE = 'audits:delete';

// Schwachstellen
export const SCHWACHSTELLEN_VIEW = 'schwachstellen:view';
export const SCHWACHSTELLEN_CREATE = 'schwachstellen:create';
export const SCHWACHSTELLEN_EDIT = 'schwachstellen:edit';
export const SCHWACHSTELLEN_DELETE = 'schwachstellen:delete';
export const SCHWACHSTELLEN_DELETE_OWN = 'schwachstellen:delete_own';
export const SCHWACHSTELLEN_SUBMIT = 'schwachstellen:submit';
export const SCHWACHSTELLEN_REVIEW = 'schwachstellen:review';

// Kunden
export const KUNDEN_VIEW = 'kunden:view';
export const KUNDEN_CREATE = 'kunden:create';
export const KUNDEN_EDIT = 'kunden:edit';
export const KUNDEN_DELETE = 'kunden:delete';

// Mitarbeiter
export const MITARBEITER_VIEW = 'mitarbeiter:view';
export const MITARBEITER_CREATE = 'mitarbeiter:create';
export const MITARBEITER_EDIT = 'mitarbeiter:edit';
export const MITARBEITER_DELETE = 'mitarbeiter:delete';

// Rechnungen
export const RECHNUNGEN_VIEW = 'rechnungen:view';
export const RECHNUNGEN_CREATE = 'rechnungen:create';
export const RECHNUNGEN_EDIT = 'rechnungen:edit';
export const RECHNUNGEN_DELETE = 'rechnungen:delete';
export const RECHNUNGEN_STATUS = 'rechnungen:status_change';
export const RECHNUNGEN_SETTINGS = 'rechnungen:settings';

// Angebote
export const ANGEBOTE_VIEW = 'angebote:view';
export const ANGEBOTE_CREATE = 'angebote:create';
export const ANGEBOTE_EDIT = 'angebote:edit';
export const ANGEBOTE_DELETE = 'angebote:delete';
export const ANGEBOTE_STATUS = 'angebote:status_change';

// Eingangsbelege externer Anbieter
export const EINGANGSBELEGE_OWN = 'eingangsbelege:own';
export const EINGANGSBELEGE_VIEW_ALL = 'eingangsbelege:view_all';
export const EINGANGSBELEGE_MANAGE = 'eingangsbelege:manage';

// Zeiterfassung
export const ZEITEINTRAEGE_VIEW_OWN = 'zeiteintraege:view_own';
export const ZEITEINTRAEGE_VIEW_ALL = 'zeiteintraege:view_all';
export const ZEITEINTRAEGE_CREATE = 'zeiteintraege:create';
export const ZEITEINTRAEGE_EDIT_OWN = 'zeiteintraege:edit_own';

// Urlaub
export const URLAUB_OWN = 'urlaub:own';
export const URLAUB_APPROVE = 'urlaub:approve';
export const URLAUB_VIEW_ALL = 'urlaub:view_all';

// Krankheit
export const KRANKHEIT_OWN = 'krankheit:own';
export const KRANKHEIT_VIEW_ALL = 'krankheit:view_all';

// Workation
export const WORKATION_OWN = 'workation:own';
export const WORKATION_APPROVE = 'workation:approve';
export const WORKATION_VIEW_ALL = 'workation:view_all';

// Anwesenheit
export const ANWESENHEIT_VIEW = 'anwesenheit:view';

// Reports
export const REPORTS_GENERATE = 'reports:generate';

// Verwaltung
export const VERWALTUNG_STAMMDATEN = 'verwaltung:stammdaten';
export const VERWALTUNG_MANAGE = 'verwaltung:manage';

// Suche
export const SEARCH = 'search:use';

// Dateien
export const FILES_VIEW = 'files:view';
export const FILES_UPLOAD = 'files:upload';
export const FILES_DELETE = 'files:delete';

// Durchfuehrungszeitraeume
export const DURCHFUEHRUNG_VIEW = 'durchfuehrung:view';
export const DURCHFUEHRUNG_MANAGE = 'durchfuehrung:manage';

// Ansprechpartner
export const ANSPRECHPARTNER_VIEW = 'ansprechpartner:view';
export const ANSPRECHPARTNER_MANAGE = 'ansprechpartner:manage';

// Risikoszenarien
export const RISIKOSZENARIEN_VIEW = 'risikoszenarien:view';
export const RISIKOSZENARIEN_MANAGE = 'risikoszenarien:manage';

// Datenimport/-export
export const DATA_EXPORT = 'data:export';
export const DATA_IMPORT = 'data:import';

// Kundenuploads
export const UPLOAD_SESSIONS_VIEW = 'upload_sessions:view';
export const UPLOAD_SESSIONS_MANAGE = 'upload_sessions:manage';

// Workbench
export const WORKBENCH_USE = 'workbench:use';

// Diskussion
export const DISKUSSION_VIEW = 'diskussion:view';
export const DISKUSSION_POST = 'diskussion:post';
export const DISKUSSION_MODERATE = 'diskussion:moderate';
